module.exports = __webpack_public_path__ + "static/GCA-Logo_large-414492e6542975627c17d068887160ce.png";